// @ts-check

import axios from "axios";
import GlobalStoreHelper from "../../modules/StorePickup/GlobalStoreHelper";

export class ProductShopPay {
  /**
   * @type {HTMLButtonElement | null}
   */
  #button;

  #settings = GlobalStoreHelper.settings();

  constructor() {
    this.#button = document.querySelector("#button-shop-pay");
  }

  #removeStickyButton() {
    const stickyButton = document.querySelector(
      ".sticky-product-description-navigation--add-to-cart #button-shop-pay"
    );

    stickyButton?.remove();
  }

  #isAvailable() {
    /**
     * @type {HTMLDivElement | null}
     */
    const alertBanner = document.querySelector(".alert-units-limit");

    if (alertBanner?.style.display !== "none") {
      this.#button?.remove();
    }

    return alertBanner?.style.display === "none";
  }

  #retryShopPayClick() {
    if (!this.#button) return;

    setTimeout(() => {
      /**
       * @type {HTMLButtonElement | null}
       */
      const shopPayButton = document.querySelector(
        "#additional-checkout-buttons ul li > div"
      );

      if (!shopPayButton) this.#retryShopPayClick();
      else shopPayButton.click();
    }, 300);
  }

  #setEvents() {
    if (!this.#button) return;

    this.#button.addEventListener("click", async (e) => {
      e.preventDefault();

      /**
       * @type {HTMLSelectElement | null}
       */
      const qtySelector = document.querySelector(
        "select#Quantity.quantity-selector"
      );

      const productId = this.#button?.dataset.productId;
      const quantity = qtySelector?.options[qtySelector.selectedIndex].value;

      /**
       * @type {HTMLButtonElement | null}
       */
      const shopPayButton = document.querySelector(
        "#additional-checkout-buttons ul li > div"
      );

      const res = await fetch("/cart.js", {
        headers: {
          "Content-Type": "application/json",
        },
      });

      const { items } = await res.json();

      const skus = [];

      const products = items.map((item) => {
        skus.push(item.sku);

        return {
          productId: item.product_id.toString(),
          qty: item.quantity.toString(),
        };
      });

      const { data } = await axios.post(
        "/apps/storeselector/api/delivery-options",
        {
          locationId: localStorage.getItem(this.#settings.locationId),
          products,
          skus,
        }
      );

      await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          attributes: {
            "Tags-To-Order": data.ordersTags,
          },
          note: "Order payed with ShopPay",
          items: [
            {
              id: productId,
              quantity,
            },
          ],
        }),
      });

      if (!shopPayButton) this.#retryShopPayClick();
      else shopPayButton.click();
    });
  }

  init() {
    this.#removeStickyButton();

    if (this.#isAvailable()) {
      this.#setEvents();
    }
  }
}

window.addEventListener("load", () => {
  const productShopPay = new ProductShopPay();

  productShopPay.init();
});
